import axios from 'axios';

// 1. Creamos una instancia configurada de Axios
const api = axios.create({
  // Ajusta la URL base según cómo tengas tus variables de entorno
  baseURL: process.env.REACT_APP_API_BASE_URL, 
  headers: {
    'Content-Type': 'application/json'
  }
});

// 2. INTERCEPTOR DE PETICIÓN (REQUEST)
// Esto inyecta el token automáticamente a todas las llamadas a tus APIs
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 3. INTERCEPTOR DE RESPUESTA (RESPONSE)
// Aquí capturamos el error 401 si el token de 1 hora expiró
api.interceptors.response.use(
  (response) => response, // Si la petición fue exitosa (200), pasa directo
  async (error) => {
    const originalRequest = error.config;

    // Si el error es 401 y aún no hemos intentado reintentar esta petición
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; // Marcamos para evitar un bucle infinito

      const refreshToken = localStorage.getItem('refreshToken');

      // Si el usuario tiene un refresh token guardado (marcó "Recordar")
      if (refreshToken) {
        try {
          // Llamamos al archivo PHP que creamos antes
const refreshResponse = await api.post('/Validaciones/RefreshToken.php', {
  refresh_token: refreshToken
});

          if (refreshResponse.data.success) {
            // Guardamos el NUEVO token corto de 1 hora
            const nuevoToken = refreshResponse.data.data.token;
            localStorage.setItem('token', nuevoToken);

            // Actualizamos la cabecera de la petición original que había fallado
            originalRequest.headers['Authorization'] = `Bearer ${nuevoToken}`;

            // Volvemos a hacer la petición original (ej: ValidarAc.php)
            return api(originalRequest);
          }
        } catch (refreshError) {
          // Si RefreshToken.php falla (pasaron 30 días o se borró de la BD)
          console.error("Refresh token inválido o caducado");
          localStorage.clear();
          window.location.href = '/';
          return Promise.reject(refreshError);
        }
      } else {
         // Si no tiene refresh token, se cierra la sesión
         localStorage.clear();
         window.location.href = '/';
      }
    }

    return Promise.reject(error);
  }
);

export default api;